import axios from "axios";
import apiClient from "../ApiClient";  // encrypted client -> FastAPI
const getNtid = () => localStorage.getItem("user_ntid") || localStorage.getItem("ntid") || "";
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";
const API_BASE_URL1 = process.env.REACT_APP_API_BASE_URL1 || "/api";

export const setAuthToken = (token) => {
 if (token) {
   apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
 } else {
   delete apiClient.defaults.headers.common['Authorization'];
 }
};
// 🚫 Manual login removed (SSO-only)
export const chatQuery = async (query, category, sessionId = "", responseType = "default") => {
 const ntid = getNtid();
 const response = await apiClient.post(`${API_BASE_URL}/chat/query`, {
   query,
   category,
   session_id: sessionId,
   response_type: responseType,
   ntID: ntid
 });
 return response.data;
};
export const logout = async () => {
  const ntid = getNtid();
  const response = await apiClient.post(`${API_BASE_URL1}/v1/logout`, 
  { ntID: ntid });
  return response.data;
 };
 
 export const sendFeedback = async (query, responseText, feedbackType) => {
   const ntid = getNtid();
   const response = await apiClient.post(`${API_BASE_URL1}/nova/feedback`, {
     query,
     response: responseText,
     feedback_type: feedbackType,
     ntID: ntid
   });
   return response.data;
  };